
<template>
      <transition name="modal">
        <form method=post 
        @submit.prevent="processForm"
        enctype=multipart/form-data >

        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                    <h1>Subir archivo de delimitación de tu región</h1>
                    <button @click="$emit('close')" >&#x2716;</button>

                </slot>
              </div>
              <div class="modal-body">
            <slot name="body2">

              <div class="row">
                <p>
                  Con esta opción puedes subir una región, para luego poder calcular su promedio PDSI y la serie de % de área bajo sequía.
                </p>
                <p>
                  Archivos válidos: kmz, kml, y zip con shapefiles. 
                  Si se sube un zip debe estar todos los archivos en la carpeta base no dentro de subcarpetas.
                </p>
                <p>
                Nota: Para evitar cálculos prolongados la geometría se simplifica y solo se toma 1 por archivo.

                </p>
                <p>
                Nota: El tamaño de los polígonos a subir debe abarcar al menos el tamaño de un pixel del Atlas, de lo contrario no subir un polígono sino que seleccionar directamente sobre el mapa del Atlas pinchando el pixel donde se ubica el área a consultar.
                </p>


                                                        </div>

                </slot>
                <hr>
                <slot name="body">
                    <input type=file @change="onFileUpload" name=file>           
                </slot>
              <hr>

              </div>

              <div class="modal-footer">
                <slot name="footer">
                <input   class="btn btn-success" style="width: 100%" type=submit value="Subir archivo">
                </slot>
              </div>
            </div>
          </div>
        </div>
        </form>

      </transition>
</template>

<script>
export default {
  name: "ModalShapeSADA",
  components: {},
  props: ["key_file_current"],
  event: "change",
  data() {
    return {
      file: null,
    };
  },
  methods: {
    onFileUpload(event) {
      this.file = event.target.files[0];
    },

    processForm() {
      if (this.file){
              let url = "./upload_shape";

      // upload file
      const formData = new FormData();
      formData.append("file", this.file, this.file.name);
      this.axios.post(url, formData, {}).then((response) => {
        this.$emit("reset_sada");
        this.$emit("update:key_file_current", response.data["key"]);
        this.$emit("close");
      }).catch((r)=>{
      alert(`Geometría no valida: ${r.response.data}`)
      })

      }

    },
  },
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
